import * as React from 'react';
export const RoundedWarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none" {...props}>
    <rect width={22} height={22} viewBox="0 0 22 22" fill="#DC2626" rx={11} />
    <g clipPath="url(#a)">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.125}
        d="M11 9v2m0 2h.005M16 11a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M5 5h12v12H5z" />
      </clipPath>
    </defs>
  </svg>
);
